import { Icon } from "../icons/Icon"
import { Image } from "../ui/Image"
import { useTranslation } from "react-i18next"

interface StyleCoverProps {
	url?: string
	title: string
}
export const StyleCover = (props: StyleCoverProps) => {
	const { t } = useTranslation("components")
	return (
		<div className="relative flex aspect-[16/9] items-center justify-center overflow-hidden rounded-xl bg-base-600">
			{props.url ? (
				<Image
					animateWhileLoading
					className="absolute inset-0 size-full object-cover"
					src={props.url}
					alt={t("styleCover.cover", { title: props.title })}
				/>
			) : (
				<Icon name="photo" size={48} className="text-base-500" />
			)}
		</div>
	)
}
